export const header = () => {


	//Hide the header as the users scrolls down, reveal it again if they scroll up
	let pageHeader = document.querySelector('#main-header');

	if(pageHeader){
		let scrollTrigger = 150; //Artbiary height in PX

		document.addEventListener('scroll', (event) => {

			if(window.scrollY > scrollTrigger){
				pageHeader.classList.add('header-scrolled');
			}else{
				pageHeader.classList.remove('header-scrolled');	
			}
			
		 		
		});
	}
	

	let hasSubMenuLinks = document.querySelectorAll('.js-show-submenu');

	hasSubMenuLinks.forEach(function(hasSubMenuLink) {
		hasSubMenuLink.addEventListener('mouseenter', () => {
			hasSubMenuLink.classList.add('hovered');
		});
		  
		hasSubMenuLink.addEventListener('mouseleave', () => {
			hasSubMenuLink.classList.remove('hovered');
		});
	});
}